import { HostListener, Directive, OnInit, OnDestroy, ChangeDetectorRef, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { ViewerConfigurationService } from "../../services/viewer-configuration.service";
import { ImageGalleryService } from "../../services/internal-services/image-gallery/image-gallery.service";
import { MeasurementCommunicatorService } from "../../../toolbars-components/services/measurement-communicator.service";
import { ToastService } from "../../services/internal-services/toast.service";
import { MapService } from "../../services/internal-services/map.service";
import { ReportService } from "../../services/internal-services/report.service";
import { FeatureFlagsService } from "../../services/internal-services/feature-flags.service";
import { FeatureFlags } from "../../model/feature-flags";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Directive()
export abstract class BaseViewerContainerComponent implements OnInit, OnDestroy {
  viewerService = inject(VIEWER_SERVICE);

  mapIndex: number;

  warningExpireInstance = false;

  warningExpireUser = false;

  subscriptions: Subscription[] = [];

  FeatureFlags = FeatureFlags;

  protected constructor(
    public mapService: MapService,
    public reportService: ReportService,
    public viewerConfigurationService: ViewerConfigurationService,
    protected galleryService: ImageGalleryService,
    public measurementCommunicatorService: MeasurementCommunicatorService,
    public toastService: ToastService,
    public cdr: ChangeDetectorRef,
    public flagService: FeatureFlagsService,
  ) {}

  ngOnInit() {
    this.mapService.mapIndex = this.mapIndex;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  @HostListener("window:keydown", ["$event"])
  onKeyPress($event: KeyboardEvent) {
    if ($event.altKey && $event.key === "0") {
      this.viewerService.toggleDeveloperTools();
    }
  }
}
